<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<a-tabs v-model="activeTab">
				<a-tab-pane key="1" tab="Fondear">
					<div class="row">
						<div class="col-md-6">
							<b>Monto</b>
							<a-input autocomplete="off" prefix="$" v-money="money" v-model="amount" />
						</div>
						<div class="col-md-6">
							<b>Comprobante</b>
							<br />
							<a-upload name="file" accept="application/pdf,image/*" :file-list="file" :remove="handleRemovePayment" :before-upload="beforeUploadPayment">
								<a-button> <a-icon type="upload" /> Seleccionar archivo </a-button>
							</a-upload>
						</div>
					</div>
				</a-tab-pane>
				<a-tab-pane key="2" tab="Historial">
					<a-table :columns="historyColumns" :dataSource="historyList" :loading="loadingHistory" rowKey="id" :pagination="{ pageSize: 10 }" bordered size="small">
						<div slot="id" slot-scope="record">#{{ record.id }}</div>
						<div slot="created_at" slot-scope="record">
							{{ moment(record.created_at).format('DD-MM-YYYY HH:mm') }}
						</div>
						<div slot="amount" slot-scope="record">
							{{ numeral(record.amount).format('$0,0.00') }}
						</div>
						<div slot="file" slot-scope="record">
							<a-button v-if="record.files && record.files.length > 0" size="small" type="link" icon="file-pdf" @click="openFileFromS3(record.files[0])" />
							<span v-else>-</span>
						</div>
					</a-table>
				</a-tab-pane>
			</a-tabs>
		</a-spin>

		<!-- Modal para visualizar archivos -->
		<a-modal width="65%" :visible="modalFileVisible" :footer="null" title="Comprobante" :closable="true" @cancel="handleCancelModalFile">
			<div class="row">
				<div class="col-12 text-center">
					<fileViewerComponent :fileURL="fileURL" v-if="modalFileVisible" />
				</div>
				<div class="col-12 text-right">
					<hr class="hrDotted" />
					<a class="ml5 btn btn-primary" :href="fileURL" target="new">Descargar archivo</a>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VMoney } from 'v-money'
import numeral from 'numeral'
import moment from 'moment'
import Swal from 'sweetalert2'
import utilities from '@/services/utilities'
//
export default {
	name: 'modalLoanFundingComponent',
	directives: {
		money: VMoney,
	},
	components: {
		fileViewerComponent: () => import('@/components/fileViewer'),
	},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters('cashFlow', ['spinnerLoaderLabel', 'spinnerLoader']),
		...mapGetters('warehouseCashflow', ['fileURL', 'modalFileVisible']),
	},
	data() {
		return {
			activeTab: '1',
			amount: 0,
			money: {
				decimal: '.',
				thousands: ',',
				precision: 0,
			},
			file: [],
			destination: '',
			loadingHistory: false,
			historyList: [],
			historyColumns: [
				{
					title: 'ID',
					scopedSlots: { customRender: 'id' },
					align: 'center',
					width: 80,
				},
				{
					title: 'Fecha',
					scopedSlots: { customRender: 'created_at' },
					align: 'center',
					width: 150,
				},
				{
					title: 'Monto',
					scopedSlots: { customRender: 'amount' },
					align: 'center',
					width: 120,
				},
				{
					title: 'Comprobante',
					scopedSlots: { customRender: 'file' },
					align: 'center',
					width: 100,
				},
			],
		}
	},
	methods: {
		moment,
		numeral,
		handleRemovePayment() {
			this.file = []
		},
		beforeUploadPayment(file) {
			this.file = [file]
			return false
		},
		openFile(url) {
			window.open(url, '_blank')
		},
		async openFileFromS3(file) {
			try {
				// Obtener URL firmada desde el backend
				const response = await this.$store.dispatch('warehouseCashflow/GET_FILE_URL', file.id)
				const signedUrl = utilities.objectValidate(response, 'data.url', null)

				if (signedUrl) {
					// window.open(signedUrl, '_blank') // Modal se abre automáticamente
				} else {
					this.$notification.error({
						message: 'Error',
						description: 'No se pudo obtener la URL del archivo',
					})
				}
			} catch (error) {
				console.error('Error al obtener URL del archivo:', error)
			}
		},
		async getHistory() {
			this.loadingHistory = true
			try {
				const response = await this.$store.dispatch('warehouseCashflow/GET_LOAN_HISTORY')
				this.historyList = utilities.objectValidate(response, 'data', [])
			} catch (error) {
				console.error('Error fetching loan history:', error)
			} finally {
				this.loadingHistory = false
			}
		},
		handleCancelModalFile() {
			this.$store.commit('warehouseCashflow/SET_STATE', {
				modalFileVisible: false,
				fileURL: '',
			})
		},
		async onSaveRecord() {
			//
			let errors = []

			if (numeral(this.amount).value() == 0) {
				errors.push(`- Ingresa monto`)
			}

			if (this.file.length == 0) {
				errors.push(`- Adjunta un comprobante`)
			}

			if (errors.length) {
				Swal.fire({
					title: 'Atención',
					html: errors.join('<br>'),
					icon: 'warning',
					confirmButtonText: 'Ok',
				})
				return false
			} else {
				//
				this.$store.dispatch('warehouseCashflow/LOAN_FUNDING', { amount: numeral(this.amount).value() }).then(async (response) => {
					await Swal.fire({
						title: 'Flujos de caja',
						text: utilities.objectValidate(response, 'message', 'Fondeo de préstamo generado con éxito'),
						icon: 'success',
						confirmButtonText: 'Ok',
					})

					// subimos comprobante
					if (this.file.length) {
						let formData = new FormData()
						formData.append('file', this.file[0])
						formData.append('id', response.data.id)
						formData.append('filetype', 'loanFunding')

						await this.$store.dispatch('cashFlow/UPLOAD_FILE', formData)
					}

					// Refrescar historial si está en ese tab
					if (this.activeTab === '2') {
						this.getHistory()
					}

					this.$emit('ok')
					this.$emit('close')
				})
			}
		},
	},
	watch: {
		visible(isVisible) {
			if (!isVisible) {
				this.amount = numeral(0).format('0,0')
				this.file = []
				this.activeTab = '1'
			} else {
				// Cargar historial cuando se abre el modal
				this.getHistory()
			}
		},
		activeTab(newTab) {
			// Recargar historial cuando se cambia al tab de historial
			if (newTab === '2') {
				this.getHistory()
			}
		},
	},
}
</script>
